module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Table_16"],"path":[{"$":{"d":"M0,2V14H16V2ZM10,7H6V5h4ZM5,7H1V5H5ZM5,8v2H1V8ZM6,8h4v2H6ZM1,13V11H5v2Zm5,0V11h4v2Zm9,0H11V11h4Zm0-3H11V8h4Zm0-3H11V5h4Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Table_16.svg
// module id = tYJu
// module chunks = 1